import type { OrganizationDetail } from "../../account";

type OrganizationIdentityStepProps = {
  data: OrganizationDetail;
  organizationType: string;
};

export function OrganizationIdentityStep({
  data,
  organizationType: type,
}: OrganizationIdentityStepProps) {
  return (
          <fieldset className="wide-field">
            <legend>1. Organisaation identiteetti</legend>
            <div className="application-field-grid">
              <label>
                Tarkka toimijatyyppi
                <select name="declaredEntityType" required defaultValue={type}>
                  <option value="shareholding_association">
                    Kalastusosakaskunta
                  </option>
                  <option value="fishery_area">Kalatalousalue</option>
                  <option value="private_water_owner">
                    Yksityinen vesialueen omistaja
                  </option>
                  <option value="state_operator">Valtion toimija</option>
                  <option value="permit_issuer">Luvanmyöntäjä</option>
                  <option value="permit_seller">Luvanmyyjä</option>
                  <option value="reseller">Jälleenmyyjä</option>
                  <option value="service_provider">Palveluntarjoaja</option>
                </select>
              </label>
              <label>
                Virallinen nimi
                <input value={data.organization.name} disabled />
              </label>
              <label>
                Y-tunnus
                <input
                  value={data.organization.business_id ?? "Ei ilmoitettu"}
                  disabled
                />
              </label>
              <label>
                Muu rekisteritunniste <small>valinnainen</small>
                <input name="officialRegisterId" maxLength={100} />
              </label>
              <label>
                Kotipaikka
                <input name="domicile" minLength={2} maxLength={120} required />
              </label>
              <label>
                Kunta
                <input
                  name="municipality"
                  minLength={2}
                  maxLength={120}
                  required
                />
              </label>
              <label>
                Puhelin <small>valinnainen</small>
                <input name="contactPhone" maxLength={50} />
              </label>
              <label className="wide-field">
                Verkkosivu <small>valinnainen</small>
                <input name="websiteUrl" type="url" pattern="https://.*" />
              </label>
            </div>
          </fieldset>
  );
}

